import PageContainer from "../../common/PageContainer";
import PageContent from "../../common/PageContent";
import ResetGuestUserMfaContent from "./ResetGuestUserMfaContent";

const EntriliaUsersManagementPage = () => {
  return (
    <PageContainer menuItems={[{ name: "reset-guest-mfa", label: "Reset Guest User MFA" }]}>
      <PageContent name="reset-guest-mfa">
        <ResetGuestUserMfaContent />
      </PageContent>
    </PageContainer>
  );
};

export default EntriliaUsersManagementPage;
